import React from 'react'

import { Link, useParams } from 'react-router-dom';


import { NewPill } from '../../../../Components/Utils/StatusPills';
import { TextSM } from '../../../../Components/Text/NormalText';
import ViewMoreAllTask from './ViewMoreTask';
import NuDate from '../../../../Components/Utils/NuDate';

function AllTaskCard({ item,getData }) {
   
    return (
        <div className="w-full border bg-white rounded-lg shadow-xl mt-1.5 mb-2">
   
        <div className="flex justify-between bg-[#ECEBF3]  rounded-t-lg items-center px-4 py-2">
          <p className=" w-auto h-auto flex justify-center font-medium text-mainColor-500 items-center text-[12px] rounded-lg">
            {item?.refNo || "#"}
          </p>
          <div className=" flex items-center gap-3">
            <div className="flex items-center gap-2 overflow-hidden">
              {item?.taskStatus &&
               
                  <NewPill text={item?.taskStatus} />
              
                }
            </div>
            <ViewMoreAllTask 
            id={item?.id} 
            getData={getData}
            data={item}
                />
          </div>
        </div>
        <div className=" px-2 pb-2">
          <div className=" px-2 w-full h-8 mt-2 truncate  overflow-hidden">
            <Link
              className="hover:text-blue-600 text-mainColor-400 font-semibold text-[12px] lg:text-[12px] xl:text-[12px] w-full flex justify-between items-center"
              to={`/tasks/all-tasks/view/${item?.id}`}
              state={{ data: item }}
            >
              {item?.taskName || "-"}
            </Link>
          </div>
          <div
            className="w-full flex justify-between items-center flex-wrap gap-2 mb-2 rounded-md p-2"
            style={{ border: "1px solid #C0C0C0" }}
          >

             <div className=" w-full  flex gap-2 flex-wrap items-center">
                          <div className=" w-full">
                            <TextSM content={"Assignee : " || "-"} />
                            <div className=" text-xs ">{item?.assignedTo?.map((assignedTo, idx) => (
                <span key={idx} className="text-xs font-medium  text-[#606279] mr-1">
                  {assignedTo.name}
                  {idx < item.assignedTo.length - 1 && ','}
                </span>
              ))}</div>
                          </div>
                        </div>

            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Start Date : " || "-"} />
                <div className=" text-xs ">
                                  {(item?.startDate != "None" && (
                                    <NuDate value={item?.startDate} format="DD-MMM-YY" />
                                  )) ||
                                    "-"}
                                </div>
              </div>
            </div>
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Due Date : " || "-"} />
                <div className=" text-xs ">
                                  {(item?.endDate != "None" && (
                                    <NuDate value={item?.endDate} format="DD-MMM-YY" />
                                  )) ||
                                    "-"}
                                </div>
              </div>
            </div>
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Duration : " || "-"} />
                <div className=" text-xs ">{item?.noOfDays || "-"}</div>
              </div>
            </div>
            <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"Priority : " || "-"} />
                <div className=" text-xs ">{item?.priority || "-"}</div>
              </div>
            </div>
  
            {/* <div className=" w-[48%]  flex gap-2 flex-wrap items-center">
              <div className=" w-full">
                <TextSM content={"InspectionDate : " || "-"} />
                <div className=" text-xs ">
                  {(item?. Date != "None" && (
                    <NuDate value={item?. Date} format="DD-MMM-YY" />
                  )) ||
                    "-"}
                </div>
              </div>
            </div> */}
  
           
          </div>
        </div>
      </div>
    );
  }

export default AllTaskCard;